import React, { Fragment } from 'react';

import { FormattedMessage } from 'react-intl';

import urls from 'src/urls/jira';
import { publishUiEvent } from 'src/utils/analytics/publish';

import emptyFolderSvg from './empty-folder.svg';
import messages from './empty-state.i18n';
import { Description, Image, LearnMoreButton } from './empty-state.styled';

const NoRelevantProjectsEmptyState = () => {
  const handleLearnMoreLinkClick = () => {
    publishUiEvent({
      action: 'clicked',
      actionSubject: 'link',
      actionSubjectId: 'noRelevantProjectsLearnMoreLinkButton',
      source: 'repositoryJiraScreen',
    });
  };

  return (
    <Fragment>
      <Image alt="" src={emptyFolderSvg} />
      <h3>
        <FormattedMessage {...messages.noRelevantProjectsHeader} />
      </h3>
      <Description>
        <FormattedMessage {...messages.noRelevantProjectsDescription} />
      </Description>
      <LearnMoreButton
        href={urls.external.docsUseJiraProjects}
        appearance="link"
        label="learnMore"
        onClick={handleLearnMoreLinkClick}
      >
        <FormattedMessage {...messages.noRelevantProjectsLearnMoreLink} />
      </LearnMoreButton>
    </Fragment>
  );
};

export default NoRelevantProjectsEmptyState;
